import {Button, Card, TextField} from "@mui/material";
import {useContext, useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../api/API";
import {BoardContext} from "./BoardContextProvider";
import {useSyncedRef} from "../../misc/SyncedRef";

export function ComposeCard(props: {
    column: number;
}) {
    const ctx = useContext(BoardContext);
    const reloadColumnsRef = useSyncedRef(ctx.reloadColumns);
    const [composing, setComposing] = useState(false);
    const [title, setTitle] = useState("");
    const create = useAsyncAction(async (input) => {
        await api.tasks2.newCardOnBoard(input)
        reloadColumnsRef.current([input.column]);

        setComposing(false);
        setTitle("")
    }, []);

    if(!composing) {
        return (
            <Button fullWidth onClick={() => setComposing(true)}>Add Card</Button>
        )
    }

    return (
        <Card style={{padding: 4, paddingTop: 12}}>
            <TextField label="Title" value={title}
                       autoFocus
                       onChange={e => setTitle(e.target.value)}
                       fullWidth size="small"
                       onKeyDown={e => {
                           if(e.key === "Enter" && title.length > 0) {
                               create.callback({
                                   title: title,
                                   column: props.column
                               })
                           }
                       }}
            />
            <div style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 3,

            }}>
                {create.LoadingElement}
                <Button size="small" onClick={() => {
                    setComposing(false);
                    setTitle("");
                }}>Cancel</Button>
                <Button variant="contained" size="small" onClick={() => {
                    create.callback({
                        title: title,
                        column: props.column
                    })
                }}>Create</Button>
            </div>
        </Card>
    )
}